import { useState } from 'react';
import { toast } from 'sonner';
import { Copy, Check, MessageCircle, Share2 } from 'lucide-react';

export const ShareShop = ({ sellerId, shopName, owner }) => {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}/seller/${sellerId}`;
  const text = owner
    ? `🛍️ Découvre ma boutique « ${shopName} » sur JOTALY !\nProduits, prix et lives en direct 👉 ${url}`
    : `🛍️ Regarde la boutique « ${shopName} » sur JOTALY 👉 ${url}`;
  const wa = `https://wa.me/?text=${encodeURIComponent(text)}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); toast.success('Lien copié'); setTimeout(() => setCopied(false), 1500); }
    catch { toast.error('Impossible de copier'); }
  };
  const native = async () => {
    if (navigator.share) { try { await navigator.share({ title: shopName, text, url }); } catch {} }
    else window.open(wa, '_blank', 'noopener');
  };
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="share-shop">
      <a href={wa} target="_blank" rel="noopener noreferrer" data-testid="share-shop-whatsapp"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-slate-900 text-xs font-bold transition-colors">
        <MessageCircle className="h-3.5 w-3.5" />{owner ? 'Partager ma boutique sur WhatsApp' : 'Partager sur WhatsApp'}
      </a>
      <button onClick={copy} data-testid="share-shop-copy" className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-slate-700 hover:border-slate-500 text-slate-200 text-xs font-semibold transition-colors">
        {copied ? <Check className="h-3.5 w-3.5 text-emerald-400" /> : <Copy className="h-3.5 w-3.5" />}Copier le lien
      </button>
      <button onClick={native} data-testid="share-shop-more" aria-label="Partager" className="inline-flex items-center justify-center h-8 w-8 rounded-full border border-slate-700 hover:border-slate-500 text-slate-300 transition-colors">
        <Share2 className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
